<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Veelgestelde vragen</h1>

      <p>
        <strong class="block">
          Hoe vaak moet ik het schilderwerk aan de buitenkant van mijn huis
          vernieuwen?
        </strong>
        Schilderwerk heeft vaak veel onderhoud nodig. Uw schilderwerk aan de
        buitenkant van uw huis moet iedere 5 – 10 jaar opgeknapt worden.
      </p>

      <p>
        <strong class="block">
          Maakt het uit in welke kleur ik mijn buitenschilderwerk schilder?
        </strong>
        Bij het gebruik van lichte kleuren wordt het zonlicht weerkaatst
        waardoor het minder warmte opneemt. Bij het gebruik van donkere kleuren
        wordt het zonlicht meer geabsorbeerd waardoor het meer warmte opneemt.
        Daardoor is de kans op barsten en bladeren groter. Kleuren die buiten
        veel gebruikt worden zijn crème, wit en donkergroen.
      </p>

      <p>
        <strong class="block">
          Hoe kan ik verkleuring van mijn schilderwerk voorkomen?
        </strong>
        Vooral in afgesloten ruimtes verkleurt verdunbare verf op terpentine
        basis . Daglicht zorgt er juist voor dat het minder verkleurt. Om
        verkleuring te voorkomen kunt u het best gebruik maken van water
        verdunbare verf. Voor radiatoren is er een speciale radiatorlak op de
        markt.
      </p>

      <p>
        <strong class="block">
          Zelf schilderen of een vakschilder inhuren?
        </strong>
        Het heeft beide voor- en nadelen. Zelf schilderen kan geld besparen,
        maar bedenk wel dat het veel tijd kost. Als u een schilder laat komen
        zal de kwaliteit beter zijn, maar het kost meer geld. Een vakschilder
        heeft beschikking over de juiste materialen en kennis. Het schilderwerk
        kan zorgen voor waardevermeerdering van uw huis.
      </p>

      <p>
        <strong class="block"> Zitten er gevaarlijke stoffen in verf? </strong>
        Op het etiket op de verpakking staat vermeld of de verf gevaarlijke
        stoffen bevat. Het etiket bevat dan een gevaarsymbool. Het is belangrijk
        om de ruimte die u verft goed te ventileren. Op deze manier wordt een
        hoge concentratie verf voorkomen.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Informatie over schildersbedrijven?',
      headDescription:
        'Meer informatie over Schildervergelijker.nl vind je op deze informatie pagina.',
      path: '/schilder-informatie/veelgestelde-vragen',
    }
  },
}
</script>
